import { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import toast from "react-hot-toast";
import { User } from "lucide-react";
import { Box, TextField } from "@mui/material";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import { axiosInstance } from "./../../utility/apiInstance";
import isUrl from "is-url";
import { useRole } from "../../components/MangeContextProvide";

const defaultTheme = createTheme();

const ManageProfile = () => {
  const [cusDetail, setCusDetail] = useState<any>({});
  const [contactInfo, setContactInfo] = useState({
    phone: "",
    email: "",
  });
  const [customerId, setCustomerId] = useState("");
  const [isMobileEditable, setIsMobileEditable] = useState(false);
  const [mobileValue, setMobileValue] = useState("");
  const [isEmailEditable, setIsEmailEditable] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [apiPassword, setApiPassword] = useState("");
  const [isWebhookEditable, setIsWebhookEditable] = useState(false);
  const [isOceanWebhookEditable, setOceanIsWebhookEditable] = useState(false);
  const [webhookValue, setWebhookValue] = useState("");
  const [oceanWebhookValue, setOceanWebhookValue] = useState("");
  const [globalData, setglobalData] = useState<null | number>(null);
  const { role } = useRole() as any;

  useEffect(() => {
    const customerInfo = async () => {
      try {
        const response = await axiosInstance.get(`/api/v1/customers-auth`);
        if (response.data.success) {
          const customerData = response.data.data;
          setCusDetail(customerData);
          setContactInfo({
            phone: customerData.contactInfo?.phone || "",
            email: customerData.contactInfo?.email || "",
          });
          setMobileValue(customerData.contactInfo?.phone || "");
          setEmailValue(customerData.contactInfo?.email || "");
          setWebhookValue(customerData.url || "");
          setOceanWebhookValue(customerData.oceanUrl || "");
          setCustomerId(customerData._id);
          setglobalData(response?.data?.data.globalData);
        }
      } catch (error) { }
    };

    customerInfo();
  }, []);

  useEffect(() => {
    getApiKey();
  }, []);
  const getApiKey = async () => {
    if (apiPassword) {
      try {
        const { data } = await axiosInstance.get(`/api/v1/api-key/getApiKey`);
        setApiPassword(data?.data?.APIKey || "");
      } catch (error) {
        toast.error("Api Key Not Found");
      }
    }
  };

  const handleCreateRegenrateApiKey = async () => {
    if (!apiPassword) {
      try {
        const { data } = await axiosInstance.post(
          `/api/v1/api-key/createApiKey`,
          {
            id: customerId,
          }
        );
        toast.success("API Key Created");
      } catch (error) {
        toast.error("API Key is not created");
      }
    } else {
      try {
        const { data } = await axiosInstance.post(
          `/api/v1/api-key/reGenerateApiKey`
        );
        getApiKey();
        toast.success("API Key Re-Genrated");
      } catch (error) {
        toast.error("API Key Is not Re-Genrated");
      }
    }
  };

  const updateCustomerInfo = async () => {
    if (role === "customeruser") {
      return;
    }
    try {
      const updateData: any = {
        contactInfo: {
          phone: mobileValue,
          email: emailValue,
        },
        url: webhookValue,
        oceanUrl: oceanWebhookValue,
        globalData: globalData,
        isProfileUpdated: true,
      };
      const data = await axiosInstance.patch(
        `/api/v1/customers-auth/customer/update/${customerId}`,
        updateData
      );

      if (data.data.success) {
        const customerData = data.data.data;
        setContactInfo({
          phone: customerData.contactInfo?.phone || "",
          email: customerData.contactInfo?.email || "",
        });
        setMobileValue(customerData.contactInfo?.phone || "");
        setEmailValue(customerData.contactInfo?.email || "");
        setWebhookValue(customerData.url || "");
        setOceanWebhookValue(customerData?.oceanUrl || "");
        toast.success(data.data.message);
      }
    } catch (error: any) {
      const errorResponse = error.response?.data?.error;

      const displayMessage =
        Array.isArray(errorResponse)
          ? errorResponse.map((err: { message: string }) => err.message).join(", ")
          : typeof errorResponse === "string"
            ? errorResponse
            : "An unexpected error occurred.";

      toast.error(displayMessage);

    }
  };

  const handleMobileDoubleClick = () => setIsMobileEditable(true);
  const handleMobileBlur = () => {
    updateCustomerInfo();
    setIsMobileEditable(false);
  };
  const handleEmailDoubleClick = () => setIsEmailEditable(true);
  const handleEmailBlur = () => {
    updateCustomerInfo();
    setIsEmailEditable(false);
  };

  const handleEmailChange = (e: any) => setEmailValue(e.target.value);

  const handleWebhookDoubleClick = () => setIsWebhookEditable(true);
  const handleWebhookBlur = (e: any) => {
    if (isUrl(e.target.value) || e.target.value === "") {
      updateCustomerInfo();
      setIsWebhookEditable(false);
    } else {
      toast.error("Webhook URL is not valid");
    }
  };

  const handleWebhookChange = (e: any) => {
    const value = e.target.value;
    setWebhookValue(value);
  };

  const handleOceanWebhookDoubleClick = () => setOceanIsWebhookEditable(true);
  const handleOceanWebhookBlur = (e: any) => {
    if (isUrl(e.target.value) || e.target.value === "") {
      updateCustomerInfo();
      setOceanIsWebhookEditable(false);
    } else {
      toast.error("Webhook URL is not valid");
    }
  };

  const handleOceanWebhookChange = (e: any) => {
    const value = e.target.value;
    setOceanWebhookValue(value);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="old_dashboard_title">

      </div>
      <div className="whiteBoxProfileMain">
        
      <div className="whiteBox">  
        <div className="manageProfileHeading">  
          <h1>Manage Profile</h1>
        </div>

          <Box
            className="maanageForm w-full "
            component="form"
            sx={(theme) => ({
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#FFFFFF" },
                "&:hover fieldset": { borderColor: "#FFFFFF" },
                "&.Mui-focused fieldset": { borderColor: "#FFFFFF" },
                "& .MuiInputBase-input": {
                  color: theme.palette.mode === "dark" ? "white" : "#36454F",
                },
              },
              "& .MuiInputLabel-root": {
                color: theme.palette.mode === "dark" ? "white" : "#36454F",
              },
            })}
            noValidate
            autoComplete="off"
          >
            <div className="manageProfileMain"> 
             {/* START Heading */}  
            <div className="manageProfileInfo"> 
              <div className="grid grid-cols-12 sm:grid-cols-12 lg:grid-cols-12 gap-0 lg:gap-3 md:gap-3 sm:gap-2">
                <div className="col-span-12 lg:col-span-6 sm:col-span-6 md:col-span-6 mb-3">
                  <div className="flex flex-col items-center justify-center mangeName">
                    <figure className="mb-3 items-center bg-yellow-50 w-[70px] h-[70px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                      <User className="text-yellow-400" size={35} />
                    </figure>
                    <aside className="">
                      <label className="mb-0 text-sm text-gray-700 text-center block" style={{ fontWeight: 600 }}>
                        Name
                      </label>
                      <TextField
                        id="name-field"
                        //label="Name"
                        value={cusDetail?.name}
                        defaultValue={cusDetail?.name}
                        InputLabelProps={{ shrink: true }}
                        slotProps={{ input: { readOnly: true } }}
                        sx={{
                          "& .MuiInputLabel-root": {
                            width: "100%",
                            textAlign: "center",
                            left: 0,
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "0 !important",
                            },
                            "&:hover fieldset": {
                              border: "0 !important",
                            },
                            "&.Mui-focused fieldset": {
                              border: "0 !important",
                            },
                            "&.Mui-focused": {
                              boxShadow: "none !important",
                            },
                          },
                          "& input": {
                            textAlign: "center",
                            outline: "none !important",
                            padding: "6px 12px", 
                            boxShadow: "none !important",
                          },
                          "& input:focus": {
                            outline: "none !important",
                            boxShadow: "none !important",
                          },
     
                        }}
                      />
                    </aside>{" "}
                  </div>
                </div>

                <div className="col-span-12 lg:col-span-6 sm:col-span-6 md:col-span-6 mb-3">
                  <div className="flex flex-col items-center justify-center mangeOrganization">
                    <figure className="mb-3 items-center bg-yellow-50 w-[70px] h-[70px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                      <CorporateFareOutlinedIcon
                        className="text-yellow-400"
                        sx={{ fontSize: 35 }}
                      />
                    </figure>
                    <aside className="">
                      <label className="mb-0 text-sm text-gray-700 text-center block" style={{ fontWeight: 600 }}>
                        Organization
                      </label>
                      <TextField
                        id="organization-field"
                        //label="Organization"
                        value={cusDetail?.organisationId?.organizationName}
                        defaultValue={cusDetail?.organisationId?.organizationName}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true }}
                        sx={{
                          "& .MuiInputLabel-root": {
                            width: "100%",
                            textAlign: "center",
                            left: 0,
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "0 !important",
                            },
                            "&:hover fieldset": {
                              border: "0 !important",
                            },
                            "&.Mui-focused fieldset": {
                              border: "0 !important",
                            },
                            "&.Mui-focused": {
                              boxShadow: "none !important",
                            },
                          },
                          "& input": {
                            textAlign: "center",
                            padding: "6px 12px", 
                            outline: "none !important",
                            boxShadow: "none !important",
                          },
                          "& input:focus": {
                            outline: "none !important",
                            boxShadow: "none !important",
                          },
                        }}
                      />
                    </aside>{" "}
                  </div>
                </div>
              </div>
            </div>
            {/* END Heading */}           

            {/* START Form */}
            <div className="profileFormOuter">
              <div className="profileForm grid grid-cols-12 sm:grid-cols-12 lg:grid-cols-12 gap-0 lg:gap-3 md:gap-3 sm:gap-2">
                <div className="col-span-12 2xl:col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6 mb-3">
                  <div className=" mangeInput">
                    <label className="mb-0 text-sm text-gray-700" style={{ fontWeight: 600 }}>
                      Mobile Number
                    </label>
                    <TextField
                      disabled={true}
                      id="mobile-number-field"
                      // label="Mobile Number"
                      value={mobileValue}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        readOnly: role === "customeruser" || !isMobileEditable,
                        style: {
                          cursor:
                            role === "customeruser"
                              ? "default"
                              : isMobileEditable
                                ? "text"
                                : "pointer",
                        },
                      }}
                      onClick={
                        role !== "customeruser"
                          ? handleMobileDoubleClick
                          : undefined
                      }
                      onBlur={handleMobileBlur}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) {
                          setMobileValue(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        const isNumberKey = e.key >= "0" && e.key <= "9";
                        const isControlKey =
                          e.key === "Backspace" ||
                          e.key === "Delete" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight";
                        if (!isNumberKey && !isControlKey) {
                          e.preventDefault();
                        }
                      }}
                        sx={{
                          "& input": {
                            background: "#f9f9f9",
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "1px solid #ddd !important",
                            },
                            "&:hover fieldset": {
                              border: "1px solid #ffb310 !important",
                            },
                            "&.Mui-focused fieldset": {
                              border: "1px solid #ffb310 !important",
                            },
                            "&.Mui-focused": {
                              boxShadow: "none !important",
                            },
                          },
                        }}
                    />
                  </div>
                </div>

                <div className="col-span-12 2xl:col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6 mb-3">
                  <div className=" mangeInput">
                    <label className="mb-0 text-sm text-gray-700" style={{ fontWeight: 600 }}>
                      Email
                    </label>
                    <TextField
                      disabled={true}
                      id="email-field"
                      //label="Email Id"
                      value={emailValue}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        readOnly: role === "customeruser" || !isEmailEditable,
                        style: {
                          cursor:
                            role === "customeruser"
                              ? "default"
                              : isEmailEditable
                                ? "text"
                                : "pointer",
                        },
                      }}
                      onClick={
                        role !== "customeruser" ? handleEmailDoubleClick : undefined
                      }
                      onBlur={handleEmailBlur}
                      onChange={handleEmailChange}
                        sx={{
                          "& input": {
                            background: "#f9f9f9",
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "1px solid #ddd !important",
                            },
                            "&:hover fieldset": {
                              border: "1px solid #ffb310 !important",
                            },
                            "&.Mui-focused fieldset": {
                              border: "1px solid #ffb310 !important",
                            },
                            "&.Mui-focused": {
                              boxShadow: "none !important",
                            },
                          },
                        }}
                    />
                  </div>
                </div>

                {role !== "customeruser" && (
                  <>
                    <div className="col-span-12 2xl:col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6 mb-3">
                      <div className=" mangeInput flex-1">
                        <label className="mb-0 text-sm text-gray-700" style={{ fontWeight: 600 }}>
                          Air Milestone Update Webhook
                        </label>
                        <TextField
                          id="webhook-field"
                          // label="Air Milestone Update Webhook"
                          value={webhookValue}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            placeholder: "Enter valid webhook URL",
                            style: {
                              cursor: !isWebhookEditable ? "pointer" : "text",
                            },
                          }}
                          onClick={handleWebhookDoubleClick}
                          onBlur={handleWebhookBlur}
                          onChange={handleWebhookChange}
                          sx={{
                            "& input": {
                              background: "#f9f9f9",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                border: "1px solid #ddd !important",
                              },
                              "&:hover fieldset": {
                                border: "1px solid #ffb310 !important",
                              },
                              "&.Mui-focused fieldset": {
                                border: "1px solid #ffb310 !important",
                              },
                              "&.Mui-focused": {
                                boxShadow: "none !important",
                              },
                            },
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-span-12 2xl:col-span-12 xl:col-span-6 lg:col-span-6 md:col-span-6 mb-3">
                      <div className=" mangeInput flex-1">
                      <label className="mb-0 text-sm text-gray-700" style={{ fontWeight: 600 }}>
                        Ocean Milestone Update Webhook
                      </label>
                        <TextField
                          id="ocean-webhook-field"
                          // label="Ocean Milestone Update Webhook"
                          value={oceanWebhookValue}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            placeholder: "Enter valid webhook URL",
                            style: {
                              cursor: !isOceanWebhookEditable ? "pointer" : "text",
                            },
                          }}
                          onClick={handleOceanWebhookDoubleClick}
                          onBlur={handleOceanWebhookBlur}
                          onChange={handleOceanWebhookChange}
                          sx={{
                            "& input": {
                              background: "#f9f9f9",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                border: "1px solid #ddd !important",
                              },
                              "&:hover fieldset": {
                                border: "1px solid #ffb310 !important",
                              },
                              "&.Mui-focused fieldset": {
                                border: "1px solid #ffb310 !important",
                              },
                              "&.Mui-focused": {
                                boxShadow: "none !important",
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
             {/* END Form */}
             </div>
          </Box>
        
      </div>
      </div>
    </ThemeProvider>
  );
};

export default ManageProfile;
